require('./change-password-template.html');

exports.inject = function(module) {
  module.config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/change-password', {
      templateUrl: 'change-password-template.html',
      controller: 'PasswordController',
    });
   
  }]);

  module.controller('PasswordController', ['$scope', '$timeout', '$compile', '$location', '$window', 'Auth', exports.controller]);
};

exports.controller = function($scope, $timeout, $compile, $location, $window, Auth) {

  $scope.data = null;

  $scope.changePassword = function($event){
    $event.preventDefault();

    if ($scope.data.password1 !== $scope.data.password2) {
      $scope.errorMessage = "The two password fields didn't match.";
    }
    else {
      Auth.changePassword($scope.data.password1, $scope.data.password2).then(
        function(response) {
          if (response.data.success){
            $window.location.replace("index.html#/profile");
            addToast("Password updated successfully");
          }
        }
      );
    }
  };

  var addToast = function(message) {
    var toast = $compile('<div toast-message class="alert alert-info">'+message+'</div>')($scope);
    angular.element('.toasts-wrapper').append(toast);
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/authorization/password-controller.js
 ** module id = 307
 ** module chunks = 0
 **/